export default value => value !== '' && !Number.isNaN(Number(value));
